import { css, html, LitElement } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import { fromExtent as polygonFromExtent } from 'ol/geom/Polygon';
import nls from '../../locales/index.nls';


export default
@i18n(nls)
class KiStationMapZoomButton extends LitElement {
  static get properties() {
    return {
      map: { Object },
    };
  }

  render() {
    // language=html
    return html`
      <style>      
      ki-station-map-zoom-button {
          position: absolute;
          top: 70px;
          right: 20px;
          pointer-events: all;
        }

        ki-station-map-zoom-button .zoom-btns {
          color: gray;
          background: white;
          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
          width: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 40px;
          font-size: 20px;
          cursor: pointer;
          overflow: hidden;
        }

        ki-station-map-zoom-button .zoom-btns .btn:hover ki-icon::part(icon){
          fill: #4a4a49;
        }
      </style>
      <div class="zoom-btns" id="zoom-btns">
        <div tabindex="0" class="btn" id="zoom-in-btn" @click="${this.zoomIn}" alt="Zoom in"><ki-icon icon="ki ki-plus"></ki-icon></div>
        <div tabindex="0" class="btn" id="zoom-out-btn" @click="${this.zoomOut}" alt="Zoom out"><ki-icon icon="ki ki-minus"></ki-icon></div>
        <div tabindex="0" class="btn" id="home-btn" @click="${this.zoomToHome}" style="display:${this.homeExtent ? 'inital': 'none'}" alt="Hone"><ki-icon icon="ki ki-home"></ki-icon></div>
      </div>
      <paper-tooltip for="zoom-in-btn" position="left">${this.i18n.t('Zoom_in_map')}</paper-tooltip>
      <paper-tooltip for="home-btn" position="left">${this.i18n.t('Zoom_to_home')}</paper-tooltip>
      <paper-tooltip for="zoom-out-btn" position="left">${this.i18n.t('Zoom_out_map')}</paper-tooltip>
    `;
  }
  
  createRenderRoot() {
  /**
   * Render template without shadow DOM. Note that shadow DOM features like
   * encapsulated CSS and slots are unavailable.
   */
    return this;
  }

  zoomIn() {
    this.map.getView().animate({
      zoom: this.map.getView().getZoom() + 1,
      duration: 500,
    });
  }

  zoomToHome() {
    this.map.getView().fit(this.homeExtent,{duration:500});

  }

  zoomOut() {
    this.map.getView().animate({
      zoom: this.map.getView().getZoom() - 1,
      duration: 500,
    });
  }
}

customElements.define('ki-station-map-zoom-button', KiStationMapZoomButton);
